export const BUILD_INFO = {
  buildNumber: '05112026171640+0530D',
  environment: 'DEV'
};